module.exports = __webpack_public_path__ + "static/img/reader.8060ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/reader.png
// module id = 0ftv
// module chunks = 1